import { Injectable, Output, EventEmitter, OnDestroy, InjectionToken, Directive } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { WidgetSettingsDTO } from '../Models/WidgetSettingsModels';

@Injectable({
  providedIn: 'root'
})
export class PopupService {
  actionEnabled$: Subject<any> = new Subject<any>();
  cancelEnabled$: Subject<any> = new Subject<any>();
  actiondisabled$: Subject<any> = new Subject<any>();
  restaurantWidgetSettings$ = new BehaviorSubject<WidgetSettingsDTO>(null);
}
